import React from 'react';
import { Card, Typography, styled } from '@harver/shared-ui';

const StyledCard = styled(Card)`
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: ${({ theme }) => theme.sizes.medium};
    max-width: ${({ theme }) => theme.getSpacing(170)};

    /* TODO: Unify how we use media queries */
    @media (min-width: 321px) {
        margin: 0 ${({ theme }) => theme.sizes.medium};
        padding: ${({ theme }) => theme.sizes.xLarge};
    }

    /* TODO: Unify how we use media queries */
    @media (min-width: 768px) {
        padding: ${({ theme }) => '0 ' + theme.getSpacing(25)};
    }
`;

const Note = styled(Typography)`
    text-align: center;
    margin-top: ${({ theme }) => theme.sizes.xLarge};
    max-width: ${({ theme }) => theme.getSpacing(170)};

    /* TODO: Unify how we use media queries */
    @media (min-width: 321px) {
        padding: ${({ theme }) => theme.sizes.xLarge};
    }

    /* TODO: Unify how we use media queries */
    @media (min-width: 768px) {
        padding: ${({ theme }) => '0 ' + theme.getSpacing(25)};
    }
`;

export interface ContentCardProps {
    children: React.ReactNode;
    note?: React.ReactNode;
}

export const ContentCard: React.FC<ContentCardProps> = ({ children, note }) => {
    return (
        <div>
            <StyledCard hasElevation>{children}</StyledCard>
            {note && <Note variant="body2">{note}</Note>}
        </div>
    );
};
